$(function(){
  $('#testimonial-slider').slick({
    infinite: true,
    prevArrow: '.testimonial__slide-prev',
    nextArrow: '.testimonial__slide-next',
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll:	2
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 1,
                slidesToScroll:	1
            }
        }
    ]
  });

  $('.slider-cards-container .slider-cards').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000
  });

  $(window).on('resize', function(){
    $('.slider-cards-container .slider-cards')[0].slick.refresh();
  })

  const observeSections = () => {
    const doActions = (entry, actions) => {

      const {
        target: el,
        isIntersecting: intersecting
      } = entry;

      actions.forEach(action => {
        switch(action) {

          case "hideNav":
            if (intersecting) {
              setMenuVisibility(false);
            }
            break;

          case "showNav":
            if (intersecting) {
              highlightMenuItem(el.id);
              setMenuVisibility(true);
            }
            break;

          case "snapToTop":
            if (intersecting) {
              snapToTop(el);
            }
            break;
          case "addIntersectionClass":
          default:
            if (intersecting) {
              el.classList.add("isIntersecting");
            } else {
              if (entry.boundingClientRect.y > 0) {
                el.classList.remove("isIntersecting");
              }
            }
        }
      })
    }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        const intersecting = entry.isIntersecting;
        const defaultAction = ["addIntersectionClass"];
        const customActions = JSON.parse(entry.target.getAttribute("data-x-observer-actions"));
        const actions = customActions ?
          [...defaultAction, ...customActions] :
          defaultAction;
  
        doActions(entry, actions, intersecting);
      });
    };
  
    const useSectionObserver = (el) => {
      const defaultOpts = {
        "rootMargin": "70px",
        "threshold": ".5"
      };

      const options = JSON.parse(el.getAttribute("data-x-observer-options")) || defaultOpts;
      const observer = new IntersectionObserver(observerCallback, options)
  
      observer.observe(el);
    }
  
    const observableSections = document.querySelectorAll("[data-x-observer]");
  
    [].forEach.call(observableSections, section => useSectionObserver(section));
  }

  const highlightMenuItem = (activeSectionId) => {
    const navItems = document.querySelectorAll(".section-nav li");
    const navItemToActivate = document.querySelector(`[data-nav-section-id="${activeSectionId}"]`);
    
    if (navItemToActivate) {
      [].forEach.call(navItems, navItem => navItem.classList.remove("active"));
  
      navItemToActivate.classList.add("active");
    }
  }

  const setMenuVisibility = (visible) => {
    const menu = document.getElementById("section-nav");
    visible ? menu.classList.add("active") : menu.classList.remove("active")
  }

  const snapToTop = (el) => {
    $("html, body").animate({
      scrollTop: el.getBoundingClientRect().top + window.scrollY - 70
    }, 100, function(){
      el.classList.add("isIntersecting");
    })
  }

  observeSections();
})
